<template>
  <div class="control">
    <b-tooltip :label="label" type="is-light">
      <button class="button is-small" @click="onClick" :class="{ 'is-link is-selected': isActive }" :icon-left="icon">
        <span class="icon" v-if="icon"><i :class="icon" /></span>
        <span v-if="$slots.default"><slot /></span>
      </button>
    </b-tooltip>
  </div>
</template>
<script>
export default {
  props: {
    isActive: Boolean,
    icon: String,
    label: String
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>